// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EntlibResponseboolean } from './entlibResponseboolean.js';
import type { IEntlibFailureResponse } from './iEntlibFailureResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class AccountV2AttestationsUpdateAttestationResponse {
    'data': boolean;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof AccountV2AttestationsUpdateAttestationResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "boolean"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return AccountV2AttestationsUpdateAttestationResponse.attributeTypeMap;
    }
}
